import React from 'react';

export default function SearchPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold">Search</h1>
      <p className="text-gray-600">Search results will appear here.</p>
    </div>
  );
}
